/* global window */
import { supportLocalStorage } from './localStorage';
import { fileNames } from 'Constants/imageUrls';

const KEY = 'b2c_meeting_flow_type';

export const setB2CMeetingFlowType = flowType => {
    if (supportLocalStorage()) {
        window.localStorage.setItem(KEY, flowType);
    }
};

export const getB2CMeetingFlowType = () => {
    if (supportLocalStorage()) {
        return window.localStorage.getItem(KEY);
    }
    return '';
};

export const getMeetingHeders = (isMeetingAccepted, isStoreVisitEnabled) => {
    if (isMeetingAccepted) {
        return isStoreVisitEnabled ? {
            headerId: 'storeVisitConfirmHeader',
            subHeaderId: 'storeVisitConfirmSubHeader',
            statusIcon: fileNames.SV_CNF
        }
            : {
                headerId: 'meetingConfirmed',
                subHeaderId: 'meetingConfirmedDetail',
                statusIcon: fileNames.MEETING_CONFIRMED
            };
    }

    return isStoreVisitEnabled ? {
        headerId: 'storeVisitCancelHeader',
        subHeaderId: 'storeVisitCancelSubHeader',
        statusIcon: fileNames.SV_CNC
    }
        : {
            headerId: 'meetingCancelled',
            subHeaderId: 'meetingCancelledDetail',
            statusIcon: fileNames.MEETING_CANCELLED
        }
    ;
};

export const getCancelationModalHeaders = isStoreVisitEnabled => {
    return isStoreVisitEnabled ? {
        cancelHeader: 'cancelModalStoreVisitTitle',
        cancelSubHeader: 'cancelModalStoreVisitSubTitle',
        cancelIcon: fileNames.SV_CNC
    }
        : {
            cancelHeader: 'cancelModalTitle',
            cancelSubHeader: 'cancelModalSubtitle',
            cancelIcon: fileNames.MEETING_CANCELLED
        }
    ;
};
